import { GALLERY_MODE } from './../../../models/card';
import { UserDataService } from 'src/app/shared/providers/user-data.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModelCardRenderedSelection, ModelCardRendered } from 'src/app/models/card';

@Component({
  selector: 'app-card-publish-panel',
  templateUrl: './card-publish-panel.component.html',
  styleUrls: ['./card-publish-panel.component.scss']
})
export class CardPublishPanelComponent implements OnInit {

  @Input() cardsToSelect: ModelCardRenderedSelection[];
  @Input() userSelectedCards: ModelCardRendered[];
  @Input() title: string;

  @Output() cardSelected = new EventEmitter<ModelCardRenderedSelection[]>();
  @Output() showCardPriceSelect = new EventEmitter<ModelCardRenderedSelection>();

  GALLERY_MODE = GALLERY_MODE


  constructor(public userDataService: UserDataService) { }

  ngOnInit(): void {
    this.userDataService.changeStateIsNavbarMainActionDisabledTo(true);
    // if(this.userSelectedCards && this.cardsToSelect) {
    //   this.cardsToSelect.forEach((currentCard) => {
    //     const isCardSelected = this.userSelectedCards.find(userSelectedCard => userSelectedCard.cardPosterMobile === currentCard.cardPosterMobile )
    //     if(isCardSelected) {
    //       currentCard.isSelected = true;
    //     }
    //     else currentCard.isSelected = false;
    //   })
    //   console.log(this.cardsToSelect)
    // }
  }

  public getDisabledCards(): ModelCardRenderedSelection[] {
    return (this.cardsToSelect || []).filter(card => card.isDisabled);
  }

  private getSelectableCards(): ModelCardRenderedSelection[] {
    return (this.cardsToSelect || []).filter(card => !card.isDisabled);
  }

  private getSelectedPublishableCards(): ModelCardRenderedSelection[] {
    return this.getSelectableCards().filter(card => card.isSelected);
  }

  onCardSelected(cardClicked: ModelCardRenderedSelection): void {
    if (!cardClicked || cardClicked.isDisabled) return;

    // Single-select: deselect all others before toggling clicked card
    this.getSelectableCards()
      .filter(c => c !== cardClicked)
      .forEach(c => c.isSelected = false);

    cardClicked.isSelected = !cardClicked.isSelected;
    const selected = this.getSelectedPublishableCards();
    this.cardSelected.emit(selected);
    this.userDataService.changeStateIsNavbarMainActionDisabledTo(selected.length === 0);
  }

  onPriceTagClicked(cardTagClicked: ModelCardRenderedSelection): void {
    this.showCardPriceSelect.emit(cardTagClicked);
  }

  selectAllItems(): void {
    this.getSelectableCards().forEach(card => card.isSelected = true);
    this.cardSelected.emit(this.getSelectedPublishableCards());
  }

  selectOrDeselectAllItems(): void {
    const selectableCards = this.getSelectableCards();
    const isAllSelected = selectableCards.every(card => card.isSelected);
    selectableCards.forEach(card => card.isSelected = !isAllSelected);
    this.cardSelected.emit(this.getSelectedPublishableCards());
  }
}
